import { component } from 'picoapp'

class FormtLinks {
  constructor(node, ctx) {
    // bindings

    // selectors
    this._node = node;

    // rewrite them...
    let links = Array.from(this._node.getElementsByTagName('a'));

    if (links.length > 0) {
      links[0].offsetHeight;
      links.forEach((link, index) => {
        if (link.href.match(/^mailto\:/) || link.href.match(/^http\:/) || link.href.match(/^https\:/)) {
          link.target = '_blank';
          link.rel = 'noreferrer noopener';
          link.classList.add('no-pjax');
          link.removeAttribute("data-pjax-state");
        }
      })
    }

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Handle unmount.
  //
  unmount() {
  }
}

export default component((node, ctx) => new FormtLinks(node, ctx))
